import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { LoginComponent } from '@auth/pages/login.component';
import { RegisterComponent } from '@auth/pages/register/register.component';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { SvgIcon } from '@services/svg-icon.service';

@Component({
  selector: 'app-register-modal',
  standalone: true,
  imports: [CommonModule, SvgIconComponent],
  templateUrl: './register-modal.html',
  styleUrl: './register-modal.scss'
})
export class RegisterModal {
  protected readonly SvgIcon = SvgIcon;

  private bottomSheet = inject(MatBottomSheet);
  private bottomSheetRef = inject(MatBottomSheetRef<RegisterModal>);

  closeRegisterModal(): void {
    this.bottomSheetRef.dismiss();
  }

  goToRegisterUser(): void {
    this.bottomSheetRef.dismiss('register');
    setTimeout(() => {
      this.bottomSheet.open(RegisterComponent, {
        disableClose: false,
        hasBackdrop: true,
        panelClass: 'register-form-bottom-sheet',
      });
    }, 0);
  }

  goToLogin(): void {
    this.bottomSheetRef.dismiss('login');
    this.bottomSheet.open(LoginComponent, {
      data: {
        source: 'register-modal',
        showSuccessFeedbackOnLogin: true,
      },
      disableClose: false,
      hasBackdrop: true,
      panelClass: 'login-bottom-sheet',
    });
  }
}
